// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__161SU","select":"Header_select__23fq5","clinic":"Header_clinic__3hUGA"};